<template>
  <div class="main">
    <div class="divLeft">
      <div class="top"  style="margin-bottom:15px;">
        <div class="top1">
          <span>blockExplorer</span>
        </div>
        <div class="top2">
          <ul>
            <li>归属地址：<span>北京</span></li>
            <li>当前状态：<span>NORMAL</span></li>
            <li>启动时间：<span>{{ blockInformation.time }}</span></li>
            <li style=" margin-bottom:30px;">累计运行时间：<span>{{ blockInformation.runTime }} 小时</span></li>
          </ul>
          <!-- <p>累计运行时间：<span>30天</span></p> -->
        </div>
      </div>
      <div class="middle"  style="margin-bottom:15px;">
        <div class="midd1">
          <div class="bor1">
            <span>最高height</span>
          </div>
          <span>{{ blockInformation.maxHeight }}</span>  
        </div>
        <div class="midd2">
          <div class="bor2">
            <span>区块数</span>
          </div>
          <span>{{ blockInformation.createBlockNum }}</span>
        </div>
        <div class="midd3">
          <div class="bor3">
            <span>交易数</span>
          </div>
          <span>{{ blockInformation.onChainTxNum }}</span>
        </div>
      </div>
      <div class="bottom">
        <div class="top1">
          <span>Block产生的频率</span>
        </div>
        <div id="zhuxingpaint">

        </div>
      </div>
    </div>
    <div class="divRight">
      <div class="r-top">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-select @change="changeBlock" style="width:150px;margin: 0 10px 0 10px;border: 2px solid #074475;border-radius: 5px;" v-model="formInline.typeValues" placeholder="请选择类型">
            <el-option
              v-for="item in typeLists"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-form-item style="border: 2px solid #074475;border-radius: 5px;">
            <el-input v-model="formInline.height" placeholder="请输入区块高度" class="label"></el-input>
          </el-form-item>
          <el-form-item style="border: 2px solid #074475;border-radius: 5px;">
            <el-input v-model="formInline.hash" placeholder="请输入交易的Hash" class="label">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" style="background:#4d74ff;color:white;font-size:18px;" @click="search"></el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="r-middle">
        <div class="midd-ul">
          <table>
              <tr>
                <td>BlockHeight</td>
                <td>{{ blockInformation.blockHeight }}</td>
              </tr>
              <tr>
                <td>计算难度</td>
                <td>{{ blockInformation.computeEasy }}</td>
              </tr>
              <tr>
                <td>产生时间</td>
                <td>{{ blockInformation.packTime }}</td>
              </tr>
              <tr>
                <td>BlockID</td>
                <td>{{ blockInformation.blockId }}</td>
              </tr>
              <tr>
                <td>交易列表</td>
                <td>{{ blockInformation.transactionHash }}</td>
              </tr>
              <!-- :label="index+1+'.TxOutRespond'" -->
            </table>
        </div>
        <div class="midd-blo">
          <div style="width: 100%;">
            <div class="project-title" style="border">
              <span v-for="(item,index) in dataB" :key="index" @click="changeOut(index)" :class="{'active':indexA==index}">
                {{ index +1}}.TxOutRespond
              </span>
            </div>
            <div>
              <!-- <el-tab-pane :label="(index + 1)+`.TxOutRespond`" class="informat"> -->
                <span style="color:#1385F9;cursor:pointer;float:right;" @click="details">详情</span>
                <table>
                  <tr>
                    <td><span style="color:red;font-size:18px;margin-top:10px;">*</span>txId:</td>
                    <td style="padding-left:116px">{{ blockInformation.transactionHash }}</td>
                  </tr>
                  <tr>
                    <td><span style="color:red;font-size:18px;">*</span>vPubAddr:</td>
                    <td style="padding-left:116px">{{ outInformation.vPubAddr }}</td>
                  </tr>
                  <tr>
                    <td><span style="color:red;font-size:18px;">*</span>userRule:</td>
                    <td style="padding-left:116px">{{ outInformation.userRule }}</td>
                  </tr>
                  <tr>
                    <td><span style="color:red;font-size:18px;">*</span>packTime:</td>
                    <td style="padding-left:116px">{{ blockInformation.packTime }}</td>
                  </tr>
                </table>
                <table style="display:none;" class="tableHide">
                  <tr>
                    <td>actionName:</td>
                    <td style="padding-left:25px;">{{ outInformation.actionName }}</td>
                  </tr>
                  <tr>
                    <td>body:</td>
                    <td style="padding-left:25px;max-width: 600px;">
                      <span style="word-wrap: break-word;" >{{ outInformation.body }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>bodyType:</td>
                    <td style="padding-left:25px">{{ outInformation.bodyType }}</td>
                  </tr>
                  <tr>
                    <td>classId:</td>
                    <td style="padding-left:25px">{{ outInformation.classId }}</td>
                  </tr>
                  <tr>
                    <td>dataName:</td>
                    <td style="padding-left:25px">{{ outInformation.dataName }}</td>
                  </tr>
                  <tr>
                    <td>moduleName:</td>
                    <td style="padding-left:25px">{{ outInformation.moduleName }}</td>
                  </tr>
                  <tr>
                    <td>traceID:</td>
                    <td style="padding-left:25px">{{ outInformation.traceID }}</td>
                  </tr>
                  <tr>
                    <td>unPackClassName:</td>
                    <td style="padding-left:25px">{{ outInformation.unPackClassName }}</td>
                  </tr>
                  <tr>
                    <td>userAction:</td>
                    <td style="padding-left:25px">{{ outInformation.userAction }}</td>
                  </tr>
                  <tr>
                    <td>userBody:</td>
                    <td style="padding-left:25px">{{ outInformation.userBody }}</td>
                  </tr>
                  <tr>
                    <td>userUnPackClassName:</td>
                    <td style="padding-left:25px">{{ outInformation.userUnPackClassName }}</td>
                  </tr>
                </table>
            </div>
          </div>
        </div>
      </div>
      <div class="r-bottom">
        <div id="content">
          <div id="four_flash">
            <div id="NodeDIv">
              <!-- <ul id="lll" class="mobile"> -->
                <transition-group name="list" tag="ul" id="lll" class="mobile">
                  <!-- <li v-for="(item,index) in dataA"  @click="liStop(item.blockHash)" :key='item.blockHeight' class="list-item">{{item.blockHeight}}/{{index}}</li> -->
                  <li v-for="(item,index) in dataA" :key='item.blockHeight' class="list-item" @click="liStop(item)" ><p></p><div style="line-height:70px;" :class="item.topA">
                    <p style="height:66px;line-height:66px;">{{item.blockHeight}}</p>
                  </div></li>
                </transition-group>
                <!-- </ul> -->
            </div>
          </div>
          <!-- <div class="but_left" style="left:4%;"><img src="../../assets/images/prev.png" alt="左"/></div>
          <div class="but_right" style="right:8%;"><img src="../../assets/images/next.png" alt="右"/></div> -->
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import $ from "jquery";
import * as d3 from 'd3';
import echarts from "echarts";
import {pathFile} from "../../assets/js/common.js";
export default {
  data() {
    return {
      formInline: {
          height: '',
          hash: '',
          typeValues:'guangdaChain'
        },
       dataA:[

        ], 
        dataB:[

        ], 
        blockInformation:{
          computeEasy:'',
          blockId:'',
          blockHeight:'',
          packTime:'',
          transactionHash:'',
          createBlockNum:'',
          onChainTxNum:'',
          maxHeight:'',
          time:'',
          runTime:''
        },
        activeName:'0',
        node:{
          domainRole:'anshun2',
          buDomain:'ANYBUDOMAIN2'
        },
        typeLists: [{
          value: 'guangdaChain',
          label: '光大'
        }, {
          value: 'datashare',
          label: '数据交换'
        }],
        outInformation:'',
        indexA:'0',
    }
  },
  mounted(){
      this.getBlock();
      this.serveGl();
      this.getBlockExplorer();
      // this.changeBlock();
    },
  methods: {
    // 切换项目
    changeBlock(){
      this.getBlock();
      this.serveGl();
      this.getBlockExplorer();
    },
    //获取block
      getBlock(){
        let params = {
            type:this.formInline.typeValues,
        };
        params = this.$qs.stringify(params,{ indices: false });
        this.axios({
            method:'post',
            url:window.API_HOST+'/guangdaChain/queryNew7Block',
            data:params,
        }).then((res)=>{
          for(var i =0;i<res.data.data.list.length;i++){
            this.dataA.push(res.data.data.list[i]);//高度大的在左边
          }
          this.blockInformation.blockHeight = this.dataA[0].blockHeight;
          this.blockInformation.computeEasy = this.dataA[0].computeEasy;
          this.blockInformation.packTime = this.dataA[0].packTime;
          this.blockInformation.blockId = this.dataA[0].blockId;
          this.blockInformation.transactionHash = this.dataA[0].transactionHash;
          this.blockInformation.createBlockNum = res.data.data.createBlockNum;
          this.blockInformation.maxHeight = res.data.data.maxHeight;
          this.blockInformation.onChainTxNum = res.data.data.onChainTxNum;
          this.dataB = this.dataA[0].list;
          if(this.dataB.length == '0'){
            this.$message({
              message: 'block高度为'+ this.dataA[0].blockHeight +'的交易信息为空，请查看',
              type: 'warning'
            })
            this.outInformation = [];
          }else{
            this.outInformation = this.dataB[0];
          }
        });
      },
      //block产生频率
      serveGl:function() {
      var myChartCity = echarts.init(document.getElementById('zhuxingpaint'));
      myChartCity.showLoading();
      let params = {
          type:this.formInline.typeValues,
      };
      params = this.$qs.stringify(params,{ indices: false });
      this.axios({
          method:'post',
          url:window.API_HOST+'/guangdaChain/queryBlockFrequence',
          data:params,
      }).then((res)=>{
            var num = new Array();
            var time = new Array();
            for (var i = 0; i < res.data.length; i++) {
              num.push(res.data[i].num);
              time.push(res.data[i].time);
            }
            // time.pop();
            // console.log(time);
            // console.log(num,time);
            myChartCity.hideLoading();
            myChartCity.setOption ({
              title: {
                  subtext: '数量(个)',
                  x:'0'
              },
              tooltip : {
                  trigger: 'axis',
                  axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                      type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                  }
              },
              grid: {
                  left: '2%',
                  right: '4%',
                  bottom: '3%',
                  containLabel: true
              },
              xAxis : [
                  {
                      type : 'category',
                      data : time,
                      boundaryGap: true,
                        axisLabel : {
                        show:true,
                        interval: 'auto',    // {number}
                        rotate: 45,
                        margin: 4,
                        formatter: '{value}',
                        textStyle: {
                            color: 'black',
                            // fontFamily: 'sans-serif',
                            fontSize: 12,
                            // fontStyle: 'italic',
                            // fontWeight:'bold',
                        }
                    },
                  }
              ],
              yAxis : [
                  {
                      type : 'value',
                      data : num,
                  }
              ],
              series : [
                  {
                      type:'bar',
                      data:num,
                      barWidth : 18,//柱图宽度
                      itemStyle:{
                          normal:{
                            color:'#809BFB'
                          }
                      },
                  },
              ]
            });
            window.addEventListener("resize",function(){
                myChartCity.resize();
            });
      })
    },
    //搜索block信息
    search(){
      let params = {
          blockHeight:this.formInline.height,
          transactionHash:this.formInline.hash,
          type:this.formInline.typeValues,
      };
      params = this.$qs.stringify(params,{ indices: false });
      if(this.formInline.height && this.formInline.hash){
        this.$message({
          message: '不能同时搜索两个条件，请重新输入',
          type: 'warning'
        });
      }else{
        this.axios({
            method:'post',
            url:window.API_HOST+'/guangdaChain/queryBlockByHeightOrHash',
            data:params,
        }).then((res)=>{
          this.dataA = res.data.data;
          this.blockInformation.blockHeight = this.dataA[0].blockHeight;
          this.blockInformation.computeEasy = this.dataA[0].computeEasy;
          this.blockInformation.packTime = this.dataA[0].packTime;
          this.blockInformation.blockId = this.dataA[0].blockId;
          this.blockInformation.transactionHash = this.dataA[0].transactionHash;
          this.dataB = this.dataA[0].list;
          if(this.dataB.length == '0'){
            this.$message({
              message: 'block高度为'+ this.dataA[0].blockHeight +'的交易信息为空，请查看',
              type: 'warning'
            });
            this.outInformation = [];
          }else{
            this.outInformation = this.dataB[0];
          }
        })
      }
    },
    //blockExplorer信息
    getBlockExplorer(){
      let params = {
          'node.domainRole':'anshun2',
          'node.buDomain':'ANYBUDOMAIN2'
      };
      params = this.$qs.stringify(params,{ indices: false });
        this.axios({
            method:'post',
            url:window.API_HOST+'/guangdaChain/queryStartTime',
            data:params,
        }).then((res)=>{
          console.log(res.data)
            if(res.data.status == 200){
              let time = res.data.data.startTime;
              this.blockInformation.time = time.substring(0,time.length-4);
              this.blockInformation.runTime = res.data.data.sumRunTime;
            }
        })
      },
      details(){
        if($('.tableHide').css('display') == 'none'){
          $('.tableHide').css('display','block');
        }
        else{
          $('.tableHide').css('display','none');
        }
      },
      //切换out
      changeOut(index){
        this.indexA = index;
        this.outInformation = this.dataB[index];
      },
      //点击block块显示对应信息
      liStop(a){
        this.blockInformation.blockHeight = a.blockHeight;
        this.blockInformation.computeEasy = a.computeEasy;
        this.blockInformation.packTime = a.packTime;
        this.blockInformation.blockId = a.blockId;
        this.blockInformation.transactionHash = a.transactionHash;
        this.dataB = a.list;
        if(this.dataB.length == '0'){
          this.$message({
            message: 'block高度为'+ a.blockHeight +'的交易信息为空，请查看',
              type: 'warning'
          })
          this.outInformation = [];
        }else{
          this.outInformation = this.dataB[0];
        }
      }

    }
  };
</script>
<style lang="scss" scoped>
// @import "../../assets/css/Border.css";
// @import '../../assets/css/block.css';
.main{
  display: flex;
  justify-content: space-between;
  // height: 100%;
  .divLeft{
    width: 20%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .top, .bottom{
      // border: 8px solid #0a4171;
      // height: 30%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      background-image: linear-gradient(157deg, #fff, #fff), linear-gradient(90deg, #1F5FF8, #64A5F7);
      border: 8px transparent solid;
      background-clip: padding-box,border-box;
      background-origin: padding-box,border-box;
      border-radius: 20px;
    }
    .top1{
      border: 3px solid #0b5282;;
      // height: 20%;
      height: 50px;
      width: 150px;
      // width: 40%;
      border-radius: 7px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 10px;
      background-image: linear-gradient(135deg,#fff,#fff),linear-gradient(302deg,#0f323f,#2d84a4);
      border: 3px transparent solid;
      background-clip: padding-box,border-box;
      background-origin: padding-box,border-box;
      span{
        font-size: 16px;
        font-weight: bold;
      }
    }
    .top2{
      // height: 60%;
      width: 90%;
      font-size: 16px;
      font-weight: bold;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: space-between;
      ul li{
        padding-top: 5px;
      }
    }
    .middle{
      border: 8px solid #0a4171;
      // height: 30%;
      height: 250px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-start;
      // margin-bottom: 15px;
      background-image: linear-gradient(157deg, #fff, #fff), linear-gradient(90deg, #1F5FF8, #64A5F7);
      border: 8px transparent solid;
      background-clip: padding-box,border-box;
      background-origin: padding-box,border-box;
      border-radius: 20px;
      .midd1, .midd2 , .midd3{
        display: flex;
        justify-content: space-around;
        width: 80%;
        // height: 20%;
        align-items: center;
        .bor1 , .bor2 , .bor3{
          border: 3px solid #0b5282;
          border-radius: 7px;
          // width: 55%;
          // height: 100%;
          height: 50px;
          width: 150px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-image: linear-gradient(135deg,#fff,#fff),linear-gradient(302deg,#0f323f,#2d84a4);
          border: 3px transparent solid;
          background-clip: padding-box,border-box;
          background-origin: padding-box,border-box;
        }
        span{
          font-size: 16px;
          font-weight: bold;
        }
      }
    }
    .bottom{
      // margin-top: 20px;
    }
    

  }
  .divRight{
    // border: 8px solid #0a4171;
    width: 78%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    background-image: linear-gradient(157deg, #fff, #fff), linear-gradient(90deg, #64A5F7, #1F5FF8);
    border: 8px transparent solid;
    background-clip: padding-box,border-box;
    background-origin: padding-box,border-box;
    border-radius: 20px;
    .r-top{
      // height: 10%;
      width: 88%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 20px;
    }
    .r-middle{
      // height: 60%;
      width: 88%;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      // border-left:3px solid black;
      .midd-ul{
        font-size: 16px;
        font-weight: bold;
        padding: 15px;
        width: 88%;
        // margin-bottom: 15px;
        tr td:nth-child(2){
          padding-left: 20px;
        }
      }
      .midd-blo{
        display: flex;
        justify-content: space-around;
        flex-direction: column;
        align-items: flex-start;
        width: 88%;
        // height: 60%;
        .informat{
          // border: 3px solid #084373;
          color: #084373;
          border-radius: 20px;
          padding: 10px;
          background-image: linear-gradient(135deg,#fff,#fff),linear-gradient(302deg,#1f88ab,#5899d0);
          border: 3px transparent solid;
          background-clip: padding-box,border-box;
          background-origin: padding-box,border-box;
          tr td:nth-child(2){
            padding-left: 20px;
          }
        }
      }
    }
    .r-bottom{
      // height: 30%;
      width: 90%;
      margin-top: 20px;
    }
  }
}
.list-item {
// display: inline-block;
margin-right: 10px;
}
.list-enter-active, .list-leave-active {
transition: all 1s;
}
.list-enter, .list-leave-to
/* .list-leave-active for below version 2.1.8 */ {
opacity: 0;
transform: translateY(120px);
}
#zhuxingpaint{
width: 100%;
height: 100%;
min-height: 200px;
}
#NodeDIv{
	width:1044px;
	text-align:center;
	position:relative;
	height:200px;
	overflow:hidden;
  text-align:center;
  margin-top: 40px;
}
#lll{
	width:987px;
	overflow:hidden;
	padding-left:0;
}
#lll li{
	position: relative;
	display: block;
	float: left;
	width: 114px;
	height: 153px;
	margin-left: 24px;
	transition:all .5s ease;
}

#lll li>div{
	position: absolute;
	top:0;
	left: 0;
	width: 114px;
	height: 153px;
	background: url("../../assets/images/block.png") no-repeat;
	text-align: center;
	line-height: 35px;
	cursor:pointer;
	transition:all .5s ease;
}
#lll li.new{
	width: 0;
}
#lll li.new>div{
	top:100%;
}
#four_flash{
	position:relative;
	width:1000px;
	height:200px;
	margin:0 auto;
	position:absolute;
	bottom:40px;
}
#four_flash{
	width:1046px;
	height:200px;
	// margin:66px auto;
	position:relative;
	overflow:hidden;
}
#four_flash ul.mobile{
	width:200000000000%;
	// height:400px;
	position:absolute;
	top:15;
	left:0;
}
#lll li:nth-child(1)>div{
	background: url("../../assets/images/block_new.png") no-repeat;
}
.but_left,.but_right{
	position:absolute;
	cursor:pointer;
}
.but_left{
	top:6%;
	left:10%;
}
.but_right{
	top:6%;
	right:13%;
}
.block_css{
	height:178px;
	line-height:178px;
	text-align:center;
}
.project-title{
  width: 96%;
  margin: 0 auto;
  font-size: 14px;
  margin: 20px 0 20px 0;
  span{
    margin-right: 30px;
    color: #999999;
    cursor: pointer;
  }
}
.active{
  color: #4D74FF !important;
  padding-bottom: 10px;
  border-bottom: 1px solid #4D74FF;
  position: relative;
  &:before{
     content: "";
     width: 0px;
     height: 0px;
     border-left: 5px solid transparent;
     border-right: 5px solid transparent;
     border-bottom: 6px solid #4D74FF;
     position: absolute;
     top: 23px;
 }
}

</style>
